import { client } from "../../infrastructure/graphql/client";
import { GET_VM_PERFORMANCE, GET_VM_PERFORMANCE_SUMMARY, GET_VM_AVAILABLE_RAM, GET_VM_METRIC_TOTAL } from "../../infrastructure/graphql/performanceQueries";

export class PerformanceService {
  async getVmPerformance(vmId, startDate, endDate) {
    try {
      const result = await client.query({
        query: GET_VM_PERFORMANCE,
        variables: { vmId, startDate, endDate },
        fetchPolicy: "network-only",
      });

      const response = result.data?.getVmPerformance;

      if (!response) {
        return { success: false, message: "No response from server", data: null };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Get VM performance error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { success: false, message: errorMessage, data: null };
    }
  }

  async getVmPerformanceSummary(vmId, startDate, endDate) {
    try {
      const result = await client.query({
        query: GET_VM_PERFORMANCE_SUMMARY,
        variables: { vmId, startDate, endDate },
        fetchPolicy: "network-only",
      });

      const response = result.data?.getVmPerformanceSummary;

      if (!response) {
        return { success: false, message: "No response from server", data: null };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Get VM performance summary error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { success: false, message: errorMessage, data: null };
    }
  }

  async getVmAvailableRam(vmId, startDate, endDate) {
    try {
      const result = await client.query({
        query: GET_VM_AVAILABLE_RAM,
        variables: { vmId, startDate, endDate },
        fetchPolicy: "network-only",
      });

      const response = result.data?.getVmAvailableRam;

      if (!response) {
        return { success: false, message: "No response from server", data: null };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Get VM available RAM error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { success: false, message: errorMessage, data: null };
    }
  }

  async getVmMetricTotal(vmId, startDate, endDate, metricType) {
    try {
      const result = await client.query({
        query: GET_VM_METRIC_TOTAL,
        variables: { vmId, startDate, endDate, metricType },
        fetchPolicy: "network-only",
      });

      const response = result.data?.getVmMetricTotal;

      if (!response) {
        return { success: false, message: "No response from server", data: null };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Get VM metric total error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { success: false, message: errorMessage, data: null };
    }
  }
}